<script setup>
import { defineModel } from 'vue';
import BitrixAccountSelectModal from '@/components/CreateConnectionComponents/BitrixUpload/components/BitrixAccountSelectModal.vue';

const account = defineModel('account');
const isModalVisible = defineModel('isModalVisible', { default: false });

function openModal() {
    isModalVisible.value = true;
}

function handleAccountUpdate(value) {
    account.value = value;
}
</script>

<template>
    <div class="w-full flex items-center gap-4 min-h-[3.5rem] py-3 px-6 border-2 border-blue-500 rounded-md select-none">
        <div
            v-if="account"
            class="flex-1 min-w-0 truncate text-sm sm:text-base font-medium"
            :class="account ? 'text-gray-900' : 'text-gray-400'"
        >
            <span class="font-bold text-base">Выбранный аккаунт: </span>
            {{ account }}
        </div>
        <div
            v-else
            class="flex-1 min-w-0 truncate text-sm sm:text-base font-medium"
            :class="account ? 'text-gray-900' : 'text-gray-400'"
        >
            Аккаунт не выбран
        </div>
        <button
            type="button"
            class="flex-shrink-0 font-bold text-white border-blue-600 border-2 bg-blue-500 px-4 py-2 rounded-lg hover:bg-blue-600 duration-150 transition-colors cursor-pointer"
            @click="openModal"
        >
            {{ account ? 'Изменить' : 'Выбрать аккаунт' }}
        </button>
    </div>

    <BitrixAccountSelectModal
        v-model="isModalVisible"
        :account="account"
        @update:account="handleAccountUpdate"
    />
</template>
